import React from 'react';
import { Phone, MessageSquare, Mail, Globe, Megaphone, Database } from 'lucide-react';
export const ChannelsWeHandle = () => {
  return <section className="py-16 bg-black relative overflow-hidden" data-id="element-62">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(255,255,255,0.02)_0,_transparent_70%)]" data-id="element-63"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-64">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-65">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-6" data-id="element-66">
            Channels We <span className="text-white" data-id="element-67">Handle</span>
          </h2>
          <p className="font-['Space_Grotesk'] text-zinc-300 font-light" data-id="element-68">
            Pick & choose or have us take on all the channels where leads come
            in
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 md:gap-8" data-id="element-69">
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center relative" data-id="element-70">
            <div className="absolute top-0 right-0 bg-white/10 px-2 py-0.5 text-xs text-white rounded-bl-sm" data-id="element-71">
              CORE
            </div>
            <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-72">
              <Phone size={28} className="text-white" data-id="element-73" />
            </div>
            <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-74">
              Phone Calls
            </h3>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-75">
              24/7 coverage for inbound calls
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center relative" data-id="element-76">
            <div className="absolute top-0 right-0 bg-white/10 px-2 py-0.5 text-xs text-white rounded-bl-sm" data-id="element-77">
              CORE
            </div>
            <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-78">
              <MessageSquare size={28} className="text-white" data-id="element-79" />
            </div>
            <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-80">
              Text Messages
            </h3>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-81">
              SMS and messaging app communications
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center relative" data-id="element-82">
            <div className="absolute top-0 right-0 bg-white/10 px-2 py-0.5 text-xs text-white rounded-bl-sm" data-id="element-83">
              CORE
            </div>
            <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-84">
              <Globe size={28} className="text-white" data-id="element-85" />
            </div>
            <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-86">
              Website Chat
            </h3>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-87">
              Instant engagement with website visitors
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center relative" data-id="element-88">
            <div className="absolute top-0 right-0 bg-white/20 px-2 py-0.5 text-xs text-white rounded-bl-sm" data-id="element-89">
              PREMIUM
            </div>
            <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-90">
              <Mail size={28} className="text-white" data-id="element-91" />
            </div>
            <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-92">Email</h3>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-93">
              Timely responses to email inquiries
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center relative" data-id="element-94">
            <div className="absolute top-0 right-0 bg-white/20 px-2 py-0.5 text-xs text-white rounded-bl-sm" data-id="element-95">
              PREMIUM
            </div>
            <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-96">
              <Megaphone size={28} className="text-white" data-id="element-97" />
            </div>
            <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-98">Ads</h3>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-99">
              Respond to leads from ad campaigns
            </p>
          </div>
          <div className="bg-gradient-to-br from-zinc-900/50 to-black/50 p-6 rounded-sm border border-white/10 backdrop-blur-sm flex flex-col items-center text-center relative" data-id="element-100">
            <div className="absolute top-0 right-0 bg-white/20 px-2 py-0.5 text-xs text-white rounded-bl-sm" data-id="element-101">
              PREMIUM
            </div>
            <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center mb-4" data-id="element-102">
              <Database size={28} className="text-white" data-id="element-103" />
            </div>
            <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-104">
              CRM Integration
            </h3>
            <p className="text-zinc-400 font-['Space_Grotesk'] text-sm" data-id="element-105">
              Seamless connection with your systems
            </p>
          </div>
        </div>
      </div>
    </section>;
};